<template>
  <MainLayout>
    <div id="contents">
      <div class="container">
        <h2>
          <span>“꿈을 체험하고 미래를 그리다”</span>
          <strong>
            한국잡월드
            <i>스마트 통합 예매</i>
          </strong>
        </h2>
        <ul>
          <li>
            <router-link to="/ind">
              <strong>개인예약</strong>
              <span>예매하기</span>
            </router-link>
          </li>
          <li>
            <router-link to="/grp">
              <strong>단체예약</strong>
              <span>예매하기</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </MainLayout>
</template>

<script>
// @ is an alias to /src
import MainLayout from '@/layouts/MainLayout.vue';

export default {
  name: 'IndGroupView',
  components: {
    MainLayout,
  },
};
</script>

<style scoped src="@/assets/css/main.css"></style>
